<div>
  <p class="group-list mb-0">{{ getSelectedGroupName() }} &nbsp;&nbsp;
    <small>{{ numberInSelectedGroup }}</small> </p>
  </div>

  <table class="mb-2 w-100">
    <tr>
      <td class="incident-search-wrapper">
        <input
          #searchinput
          class="listSearch form-control"
          type="text"
          [(ngModel)]="query.name"
          [placeholder]="'Search ' + getSelectedGroupName()"
          (focus)="focusSearch()"
          autofocus
          />
        </td>
      </tr>
    </table>

    <div >
      <table class="table table-striped table-hover custom-table">
        <tbody>
          @for (item of getGroupList(); track item) {
            <tr>
              <td>
                {{ item.name }} ({{ item.count }})
              </td>
              <td>
                <i
                  class="fa fa-info"
                  (click)="orgAlert()"
                  title="info"
                ></i>
              </td>
              <td>
                <i
                  class="fa fa-envelope"
                  (click)="sendGroupMail(item)"
                  title="send mail"
                ></i>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>